import React, { useRef } from "react";
import { InputAdornment, styled, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchField = styled(TextField)({
  borderRadius: "4px",
  fontSize: "12px",
  height: "40px",
  lineHeight: "14.06px",
  background: "#f9f9f9",
  // boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.16)",
  // borderBottom: "1px solid #999999 !important",
});

function SearchNew({handleSearch }) {
  const searchInputRef = useRef(null);

  const setSearchValue = (value) => {
    if (searchInputRef.current) {
      searchInputRef.current.value = value;
    }
  };

  return (
    <SearchField
      fullWidth
      size="small"
      height="40px"
      label=""
      placeholder="search"
      variant="outlined"
      inputRef={searchInputRef}
      onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSearch( searchInputRef.current.value);
                }
         }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="start">
            <SearchIcon
              className="gray-clr"
              sx={{ cursor: "pointer" }}
              onClick={() => setSearchValue('New search value')}
            />
          </InputAdornment>
        ),
      }}
    />
  );
}

export default SearchNew;
